export default __webpack_public_path__ + "static/media/closet5-after1-480w.e508b618.webp";